"use strict";

require("./index.less");
require("../../button/style");
require("../../tag/style");